import {
  PUT_PROJECTS_CATALOG,
  PUT_PROJECTS_CATALOG_SUCCESS,
  PUT_PROJECTS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putProjectsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_PROJECTS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_PROJECTS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_PROJECTS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
